import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import "../../styles/customers/createCustomer.scss";
import "../../styles/customers/customers.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";
import CustomerMap from "../maps/customerMap";
import HtmlContent from "../commoncomponents/htmlContent";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { searchSuggestionAPI, reverseGeoCodeAPI, GeoCodeAPI } from "../../utils/mapapi";

class CreateCustomer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      timeZoneArr: [],
      lat: -37.8136276,
      lng: 144.9630576,
      address: "Thelangerin Rd, Hay NSW 2711, Australia",
      suggestions: [],
      suggestionVisibility: false,
      searchText: "",
      name: "",
      description: "",
      status: "Active",
      timeZone: "",
      tempA: "8",
      tempB: "-12",
      speedException: 3,
      error: false,
      errorSearch: false,
      nameError: false,
      descriptionError: false,
      statusError: false,
      timeZoneError: false,
      speedError: false,
      temperatureThresholdDuration: 30,
      temperatureThresholdDurationError: false,
      fridgeEventTrigger: "on",
      engineEventTrigger: "off",
    };
  }
  async componentDidMount() {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllTimeZone`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({ timeZoneArr: response.data });
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }

  handlePositionChange = async (position) => {
    this.setState({ lat: position.lat, lng: position.lng });

      try {
          let address = await reverseGeoCodeAPI(position.lat, position.lng);
          this.setState({ address });
      } catch (e) {
          if (e.response.status == "401") {
              this.props.history.push("/login");
          }
          console.log(`😱 Axios request failed: ${e}`);
      }
  };

  handleCancel = () => {
    this.props.history.push("/customers");
  };

  handleName = (evt) => {
    if (evt.target.value == "") {
      this.setState({ nameError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.setState({ name: evt.target.value });
  };

  handleDescription = (evt) => {
    if (evt.target.value == "") {
      this.setState({ descriptionError: true });
    } else {
      this.setState({ descriptionError: false });
    }
    this.setState({ description: evt.target.value });
  };

  handleStatus = (evt) => {
    if (evt.target.value == "") {
      this.setState({ statusError: true });
    } else {
      this.setState({ statusError: false });
    }
    if (evt.target.value == "Active") {
      this.setState({ status: "Active" });
    } else {
      this.setState({ status: "Disable" });
    }
  };

  handleFridgeEventTrigger = (evt) => {
    if (evt.target.value == "Fridge-On") {
      this.setState({ fridgeEventTrigger: "on" });
    } else if (evt.target.value == "Fridge-Off") {
      this.setState({ fridgeEventTrigger: "off" });
    } else {
      this.setState({ fridgeEventTrigger: "always" });
    }
  };

  handleEngineEventTrigger = (evt) => {
    if (evt.target.value == "Engine-On") {
      this.setState({ engineEventTrigger: "on" });
    } else if (evt.target.value == "Engine-Off") {
      this.setState({ engineEventTrigger: "off" });
    } else {
      this.setState({ engineEventTrigger: "always" });
    }
  };

  handleTimeZone = (evt) => {
    if (evt.target.value == "") {
      this.setState({ timeZoneError: true });
    } else {
      this.setState({ timeZoneError: false });
    }
    this.state.timeZoneArr.forEach((time) => {
      if (time.timeZoneCity == evt.target.value) {
        this.setState({ timeZone: time.timeZonesId });
      }
    });
  };

  //Map searching and search suggestion starts here
  handleLocationChange = (searchText) => {
    this.setState({ searchText });
    this.handleSearchSuggestion(searchText);
  };

    handleSearch = async () => {
        try {
            console.log("searec1", this.state.searchText);
            const { lat, lng } = await GeoCodeAPI(this.state.searchText);

            if (lat !== 0 && lng !== 0) {
                this.setState({
                    lat: lat,
                    lng: lng,
                });
            } else {
                this.setState({ errorSearch: true });
                setTimeout(() => {
                    this.setState({ errorSearch: false });
                }, 1000);
            }

        } catch (e) {
            if (e.response.status == "401") {
                this.props.history.push("/login");
            }
            console.log(`😱 Axios request failed: ${e}`);
        }
    };

    handleSearchSuggestion = async (query) => {
        if (query != "") {
            this.setState({ suggestionVisibility: false });
        }
        this.setState({ suggestionVisibility: true });
        try {
            const items = await searchSuggestionAPI(query);
            this.setState({ suggestions: items });
        } catch (e) {
            console.log(e);
        }
        // }
    };
  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      console.log("enter press here! ", event.target.value);
      this.handleSuggestionClick(event.target.value);
    }
  };
    handleSuggestionClick = async (place) => {
        var nwlocation = place.replace("<b>", "");
        var location = nwlocation.replace("</b>", "");

        this.setState({ searchText: location, suggestionVisibility: false });
        try {
            console.log("searecyy", location);
            const { lat, lng } = await GeoCodeAPI(location);

            if (lat !== 0 && lng !== 0) {
                this.setState({
                    lat: lat,
                    lng: lng,
                });
                let position = {
                    lat: lat,
                    lng: lng,
                };
                this.handlePositionChange(position);
            } else {
                this.setState({ errorSearch: true });
                setTimeout(() => {
                    this.setState({ errorSearch: false });
                }, 1000);
            }
        } catch (e) {
            console.log(`😱 Axios request failed: ${e}`);
        }
    };

  //Map searching and search suggestion ends here
  handleTempA = (e) => {
    this.setState({ tempA: e.target.value });
  };
  handleTempB = (e) => {
    this.setState({ tempB: e.target.value });
  };
  handleSpeedException = (e) => {
    if (e.target.value == "") {
      this.setState({ speedError: true });
    } else {
      this.setState({ speedError: false });
    }
    this.setState({ speedException: e.target.value });
  };

  handleTemperatureThresholdException = (e) => {
    if (e.target.value == "") {
      this.setState({ temperatureThresholdDurationError: true });
    } else {
      this.setState({ temperatureThresholdDurationError: false });
    }
    this.setState({ temperatureThresholdDuration: e.target.value });
  };

  handleSubmit = async () => {
    this.validationCheck();

    if (
      this.state.name &&
      // this.state.description &&
      this.state.timeZone &&
      this.state.speedException &&
      this.state.temperatureThresholdDuration
    ) {
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(
          `${apiHost}/api/Customer/CustomerRegistration`,
          {
            Name: this.state.name,
            Description: this.state.description,
            Status: this.state.status,
            TimeZonesId: this.state.timeZone,
            Latitude: this.state.lat,
            Longitude: this.state.lng,
            SpeedExceptionDurationLimit: this.state.speedException,
            TempA: this.state.tempA,
            TempB: this.state.tempB,
            TemperatureThresholdDuration: this.state
              .temperatureThresholdDuration,
            FridgeEventTrigger: this.state.fridgeEventTrigger,
            EngineEventTrigger: this.state.engineEventTrigger,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        if (response.status == "200") {
          this.props.history.push("/customers");
          this.props.setLoadingPageAction(false);
        }
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
        this.setState({ error_authorisation: true });
      }
    } else {
      this.setState({ error: true });
      setTimeout(() => {
        this.setState({ error: false });
      }, 3000);
    }
  };

  validationCheck = () => {
    if (!this.state.name) {
      this.setState({ nameError: true });
    }
    // if (!this.state.description) {
    //   this.setState({ descriptionError: true });
    // }
    if (!this.state.status) {
      this.setState({ statusError: true });
    }
    if (!this.state.timeZone) {
      this.setState({ timeZoneError: true });
    }
    if (!this.state.speedException) {
      this.setState({ speedError: true });
    }
    if (!this.state.temperatureThresholdDuration) {
      this.setState({ temperatureThresholdDurationError: true });
    }
  };

  render() {
    const {
      timeZoneArr,
      lat,
      lng,
      address,
      nameError,
      descriptionError,
      statusError,
      timeZoneError,
      speedError,
      temperatureThresholdDurationError,
    } = this.state;
    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Create Customer </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper customer-edit-page">
              <div className="customer-edit-header">
                <div>
                  <span className="customer-edit-kicker">Customer creator</span>
                  <h2>New Customer</h2>
                  <div className="customer-edit-subtitle">
                    <span className={this.state.status === "Active" ? "record-badge-active" : "record-badge-disabled"}>
                      {this.state.status === "Active" ? "Active" : "Disabled"}
                    </span>
                    <span>{this.state.timeZone ? "Timezone selected" : "Select timezone"}</span>
                    <span>{lat}, {lng}</span>
                  </div>
                </div>
                <div className="customer-edit-actions">
                  <Button variant="outline-secondary" onClick={() => this.handleCancel()}>
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={() => this.handleSubmit()}>
                    Create Customer
                  </Button>
                </div>
              </div>

              <Form className="customer-edit-form-modern">
                <section className="customer-edit-section">
                  <div className="customer-edit-section-title">
                    <h3>Customer Identity</h3>
                    <p>Core customer details and account status.</p>
                  </div>
                  <div className="customer-edit-grid">
                    <Form.Group controlId="customerName">
                      <Form.Label>Name</Form.Label>
                      <Form.Control onChange={this.handleName} type="text" />
                      <p style={nameError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Name field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="customerStatus">
                      <Form.Label>Status</Form.Label>
                      <Form.Control as="select" onChange={this.handleStatus}>
                        <option>Active</option>
                        <option>Disabled</option>
                      </Form.Control>
                      <p style={statusError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Status field is required.
                      </p>
                    </Form.Group>

                    <Form.Group className="customer-edit-wide" controlId="customerDescription">
                      <Form.Label>Description</Form.Label>
                      <Form.Control as="textarea" rows="3" onChange={this.handleDescription} />
                      <p style={descriptionError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The Description field is required.
                      </p>
                    </Form.Group>
                  </div>
                </section>

                <section className="customer-edit-section">
                  <div className="customer-edit-section-title">
                    <h3>Operational Settings</h3>
                    <p>Event trigger rules, thresholds and exception timing.</p>
                  </div>
                  <div className="customer-edit-grid">
                    <Form.Group controlId="customerFridgeTrigger">
                      <Form.Label>Fridge Event Trigger</Form.Label>
                      <Form.Control as="select" onChange={this.handleFridgeEventTrigger}>
                        <option>Fridge-On</option>
                        <option>Fridge-Off</option>
                        <option>Always</option>
                      </Form.Control>
                    </Form.Group>

                    <Form.Group controlId="customerEngineTrigger">
                      <Form.Label>Engine Event Trigger</Form.Label>
                      <Form.Control as="select" onChange={this.handleEngineEventTrigger}>
                        <option>Engine-On</option>
                        <option>Engine-Off</option>
                        <option>Always</option>
                      </Form.Control>
                    </Form.Group>

                    <Form.Group controlId="customerTempA">
                      <Form.Label>Temp A Threshold</Form.Label>
                      <Form.Control onChange={this.handleTempA} type="text" value={this.state.tempA} />
                    </Form.Group>

                    <Form.Group controlId="customerTempB">
                      <Form.Label>Temp B Threshold</Form.Label>
                      <Form.Control onChange={this.handleTempB} type="text" value={this.state.tempB} />
                    </Form.Group>

                    <Form.Group controlId="customerSpeedException">
                      <Form.Label>Speed Exception Duration (minutes)</Form.Label>
                      <Form.Control onChange={this.handleSpeedException} type="number" value={this.state.speedException} />
                      <p style={speedError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The speed field is required.
                      </p>
                    </Form.Group>

                    <Form.Group controlId="customerTemperatureDuration">
                      <Form.Label>Temperature Threshold Duration (minutes)</Form.Label>
                      <Form.Control onChange={this.handleTemperatureThresholdException} type="number" value={this.state.temperatureThresholdDuration} />
                      <p style={temperatureThresholdDurationError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The temperature threshold duration field is required.
                      </p>
                    </Form.Group>
                  </div>
                </section>

                <section className="customer-edit-section">
                  <div className="customer-edit-section-title">
                    <h3>Location</h3>
                    <p>Timezone, geofence centre and searchable customer location.</p>
                  </div>
                  <div className="customer-edit-grid">
                    <Form.Group controlId="customerTimeZone">
                      <Form.Label>Timezone</Form.Label>
                      <Form.Control as="select" onChange={(e) => this.handleTimeZone(e)}>
                        <option value="default">Select TimeZone</option>
                        {timeZoneArr.map((time, index) => (
                          <option key={index}>{time.timeZoneCity}</option>
                        ))}
                      </Form.Control>
                      <p style={timeZoneError ? { color: "#a94442", fontSize: "14px" } : { display: "none" }}>
                        The TimeZone field is required.
                      </p>
                    </Form.Group>

                    <div className="customer-location-summary">
                      <Form.Label>Address</Form.Label>
                      <strong>{address || "-"}</strong>
                      <span>{lat}, {lng}</span>
                    </div>

                    {this.state.errorSearch && (
                      <p className="error-text customer-edit-wide">No response</p>
                    )}

                    <div className="customer-map-panel customer-edit-wide">
                      <div className="containerMap">
                        <CustomerMap
                          onPositionChange={this.handlePositionChange}
                          lat={lat}
                          lng={lng}
                        ></CustomerMap>
                        <div className="overlaySearch">
                          <div className="inputSuggestions">
                            <Form.Control
                              value={this.state.searchText}
                              onChange={(e) => this.handleLocationChange(e.target.value)}
                              onKeyPress={(e) => this.handleKeyPress(e)}
                              autoComplete="off"
                              type="text"
                              placeholder="Search location"
                            />
                            {this.state.suggestionVisibility && (
                              <ul>
                                {this.state.suggestions &&
                                  this.state.suggestions.map((item, index) => {
                                    return (
                                      <li
                                        key={item.address.label}
                                        onClick={() => this.handleSuggestionClick(item.address.label)}
                                      >
                                        <HtmlContent html={item.address.label} />
                                      </li>
                                    );
                                  })}
                              </ul>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {this.state.error && (
                  <p className="error-text customer-edit-error">
                    Please fill all the Required fields
                  </p>
                )}

                <div className="customer-edit-footer">
                  <Button variant="outline-secondary" onClick={() => this.handleCancel()}>
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={() => this.handleSubmit()}>
                    Create Customer
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateCustomer);
